import { getRequest, postRequest, putRequest, deleteRequest } from '@/api/request'


// 优惠券列表
export const getCouponList = (params) => {
  return getRequest('shop/coupon/list', params);
};
